import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IOrganizer } from '@cf/temp/services';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
  selector: 'cf-booking-error',
  templateUrl: './booking-error-page.component.html',
  styleUrls: ['./booking-error-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgxTolgeeModule],
  host: {
    class:
      'tw:flex tw:flex-col tw:items-center tw:justify-center tw:gap-8 tw:min-h-screen tw:px-2 tw:py-4',
  },
})
export class BookingErrorPageComponent {
  organizer!: IOrganizer;

  constructor(route: ActivatedRoute) {
    if (route.snapshot.queryParams.params) {
      this.organizer = JSON.parse(route.snapshot.queryParams.params)?.organizer;
    }
  }
}
